import { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { getAdminAndGuestDiners } from 'bento-ordering/cart/selectors/index';

const GUEST_LIST_DISPLAY_LIMIT = 3;

const useGroupOrderDinersCart = () => {
  const { adminDiner, guestDiners } = useSelector(getAdminAndGuestDiners);
  const [renderShowAllGuestsButton, setRenderShowAllGuestsButton] = useState(
    false
  );

  const guestDinersCount = guestDiners.length;
  const adminCount = !isEmpty(adminDiner) ? 1 : 0;
  const dinersCount = guestDinersCount + adminCount;

  /**
   * When rendering the Show all guests button we want to limit the display
   * of the number of guests diners. Otherwise we show the whole list of guests.
   */
  const guestDinersList = useMemo(() => {
    return renderShowAllGuestsButton
      ? guestDiners.slice(0, GUEST_LIST_DISPLAY_LIMIT)
      : guestDiners;
  }, [guestDiners, renderShowAllGuestsButton]);

  /**
   * When the guest diners count is greater than the display limit
   * we want to render the Show all guests button.
   */
  useEffect(() => {
    if (guestDinersCount > GUEST_LIST_DISPLAY_LIMIT) {
      setRenderShowAllGuestsButton(true);
    }
  }, [guestDinersCount]);

  const hideShowAllGuestsButton = () => setRenderShowAllGuestsButton(false);

  return {
    adminDiner,
    guestDiners: guestDinersList,
    dinersCount,
    renderShowAllGuestsButton,
    hideShowAllGuestsButton
  };
};

export default useGroupOrderDinersCart;
